export default "__VITE_ASSET__Br5RENat__"